import React from 'react';
import PropTypes from 'prop-types';
import styles from './Chats.module.scss';
import { clickTracker } from '../../lib/common';

const IssuesList = ({ issuTypesArr, handleRedirectDummyTicketCreate }) => {
  const iconsObj = {
    LEADS: styles.ChatLeads,
    'DATA CHANGES/VALIDATION REQUEST': styles.ChatEditBusiness,
    ECS: styles.ChatEcs,
    'CONTRACT RELATED': styles.ChatContract,
    'Payments & Invoice': styles.ChatPayments,
    'Edit Listing': styles.ChatEdit,
    Others: styles.ChatOthers,
    'SPECIAL NUMBER ISSUE': styles.ChatSpecialNum,
    Banner: styles.ChatBanner,
    'COMPLAINT-SALES TEAM': styles.ChatComplaint,
    'PAYMENTS & REFUNDS': styles.ChatPayments,
  };
  return (
    <>
      <div className={`${styles.ExecutiveBox} mb-20`}>
        <div className={`${styles.TextBox}`}>
          <div className={`${styles.ExecutiveIcon} csicon`} />
          <div className={`${styles.ChatText} font14 fw500 color111`}>Hi! How can we assist you today? </div>
        </div>
      </div>
      <div className={`${styles.ChatCategory} mb-20`}>
        <ul className={`${styles.ChatCategoryList}`}>
          {issuTypesArr &&
            issuTypesArr?.length > 0 &&
            issuTypesArr?.map((each, idx) => (
              <li key={idx} className={`${styles.ChatCategoryItem}`}>
                <div
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => {}}
                  onClick={async () => {
                    const label = `${each?.replace(/\s+/g, '')}`;
                    await clickTracker(`Issue_${label}`, 'Selectissue');
                    handleRedirectDummyTicketCreate(each);
                  }}
                >
                  <div
                    className={`${iconsObj?.[each] ? iconsObj?.[each] : styles.ChatDefault} ${styles.ChatCategoryIcon} csicon`}
                  />
                  <div className={`${styles.ChatCategoryTxt} font14 fw600 color111 pl-10 pr-10`}>{each}</div>
                  <div className={`${styles.ChatCategoryArrow} csicon`} />
                </div>
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

export default IssuesList;
IssuesList.propTypes = {
  issuTypesArr: PropTypes.array,
  handleRedirectDummyTicketCreate: PropTypes.func,
};
